import { useEvent } from "src/hooks/useEvent";
import { WorldLoader } from "src/types/WorldLoader";
import type { Editor } from "src/types/Editor";
import type { Zone } from "src/types/Zone";

/**
 * Regenerate after a zone's type changes, then repopulate just that zone with
 * the buildings from the first generated design — leaving the other zones
 * untouched. Shared by the Inspector and the Brief panel so switching a zone
 * between buildable/exclusion behaves identically wherever the control lives.
 */
export function useZoneTypeChange(editor: Editor) {
  return useEvent(async (zone: Zone) => {
    const world = editor.world;
    if (!world) return;
    await editor.regenerate(false);
    const loader = new WorldLoader();
    const generatedItem = editor.designGenerator.list.at(0);
    if (!generatedItem) return;
    const generatedWorld = await loader.loadFromDesignGenerator(generatedItem, world);
    const selectedZone = generatedWorld.zones.find((z) => z.id === zone.id);
    if (!selectedZone) return;
    const zones = world.zones.map((z) => (z.id === zone.id ? selectedZone.clone() : z));
    world.replaceZones(zones);
  });
}
